/** Registers the OptionButton parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseOptionButton } from './parser';
const optionButtonRegistration = {
    typeName: 'OptionButton',
    parser: parseOptionButton,
};
nodeRegistry.register(optionButtonRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map